import { get, post } from './apiUtils';
import { UserSubscription } from '../models/userSubscription';

export interface CheckoutSession {
    url: string;
}

export interface PortalSession {
    url: string;
}

export const getSubscriptionStatus = async (): Promise<UserSubscription> => {
    return get('/api/UserSubscription');
};

export const createCheckoutSession = async (): Promise<CheckoutSession> => {
    return post('/api/UserSubscription/create-checkout-session');
};

export const createPortalSession = async (): Promise<PortalSession> => {
    const response = await post<PortalSession>('/api/usersubscription/portal');
    return response;
}